import React, { useState } from 'react';
import ReactPaginate from 'react-paginate';
import JobCard from './JobCard';
import './JobCards.css';

import {
    BiChevronLeft,
    BiChevronRight
} from 'react-icons/bi';

function JobCards({ apiData, pagination }) {

    const itemsPerPage = 4;

    const [itemsOffset, setItemOffset] =
        useState(pagination || 0);

    const endOffset =
        itemsOffset + itemsPerPage;

    const currentItems =
        apiData.slice(itemsOffset, endOffset);

    const pageCount =
        Math.ceil(apiData.length / itemsPerPage);

    const handlePageClick = (event) => {

        const newOffset =
            event.selected * itemsPerPage;

        setItemOffset(newOffset);

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return (
        <div>

            <div className="jobcards-container">

                {currentItems.map((item, i) => (

                    <JobCard
                        key={i}
                        data={item}
                        pagination={itemsOffset}
                    />

                ))}

            </div>


            {pageCount > 1 && (

                <ReactPaginate

                    breakLabel={
                        <span className="page-btn">
                            ...
                        </span>
                    }

                    nextLabel={
                        <span className="page-btn">
                            <BiChevronRight />
                        </span>
                    }

                    previousLabel={
                        <span className="page-btn">
                            <BiChevronLeft />
                        </span>
                    }

                    onPageChange={handlePageClick}

                    pageCount={pageCount}

                    pageRangeDisplayed={3}

                    containerClassName="pagination-container"

                    pageClassName="pagination-page"

                    activeClassName="active-page"

                />

            )}

        </div>
    );
}

export default JobCards;